export default "__VITE_ASSET__B4jm6nXD__"